module.exports = __webpack_public_path__ + "static/media/pizza-milano-3.ef1088ef.jpg";